export const appsBusinessSources = "/apps/business/business_sources";
